export default {
      id: "Note_icon_geel-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#Note_icon_geel-usage",
      toString: function () {
        return this.url;
      }
    }